import { Tag, Typography } from 'antd';
const { Title } = Typography;

const TopMovie = ({topMovie, topM}) => {
  return (
    <div className='top-movie-card' style={{backgroundImage: `url(${topMovie.banner || topM})`,}}> 
        {topMovie.name ? 
        <div className='glass-card'> 
            <h2 style={{marginTop: "0px", color: "white"}}>{topMovie.name}</h2>
            <h1 style={{marginTop: "0px", color: "white"}}>{topMovie.total_collection} EUR</h1>
            <div >
                <Tag color="magenta">{topMovie.display_language}</Tag>
                <Tag color="red">{topMovie.status === "now_showing" ? "Now Showing" : "Upcoming / Archived"}</Tag>
            </div>
        </div> : 
        <div style={{textAlign: "center", color:"white"}}>
            <Title level={2} style={{ color:"white"}}>Top Movie</Title>
            <p>Of last 30 days</p>
        </div >}
    </div>
  )
}

export default TopMovie
